import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first, map, switchMap } from 'rxjs/operators';

import { PhysicalStoreModelsTransformer } from '../transformers/store-locator.transformer';

import { DroppointListsDetail, DroppointListsRequestConfiguration, PickupPointInfo } from './models/droppoint-lists.models';

import { ApiDroppointListsService } from '@api/_api/api-store-locator/api-droppoint-lists/api-droppoint-lists.service';
import { ApiDroppointLists, ApiDeliveryPointList } from '@api/_api/api-store-locator/api-droppoint-lists/models/api-droppoint-lists.models';
import { EcommerceContext } from '@core/domain/models/context.models';
import { getStoreAndLanguage } from '@core/infrastructure/state/core.selectors';
import { RequestParams } from '@core/services/http-requests/http-requests.service';

/**
 * Servicio para interactuar con los puntos de entrega del buscador de puntos de entrega
 */

@Injectable()
export class DroppointListsService {
    // Definición de propiedades
    public droppoints: DroppointListsDetail[];

    public deliveryPoints: PickupPointInfo[];

    public relatedInfo: string;

    private requestParameters: RequestParams;

    private readonly context: EcommerceContext;

    constructor(
        private readonly apiDroppointListsService: ApiDroppointListsService,
        private readonly store: Store,
    ) {}

    /**
     * Función para obtener un listado de tiendas cercanas en base a una localización
     * @param requestConfiguration Configuración de la consulta
     * @return Objeto de tipo observable con un listado de tiendas
     */
    public getDroppoints(requestConfiguration: DroppointListsRequestConfiguration): Observable<DroppointListsDetail[]> {
        return this.store.select(getStoreAndLanguage).pipe(
            first(),
            switchMap((storeAndLanguage) => {
                this.requestParameters = [
                    { key: 'languageId', value: storeAndLanguage.languageId },
                    { key: 'latitude', value: requestConfiguration.latitude },
                    { key: 'longitude', value: requestConfiguration.longitude },
                    { key: 'countryCode', value: storeAndLanguage.countryCode },
                ];
                return this.apiDroppointListsService.getDroppoints(this.requestParameters);
            }),
            map((apiDroppointLists: ApiDroppointLists): DroppointListsDetail[] => {
                // Transforma los datos recibidos desde la API
                // TODO ECOMDUTI-20990 Hay que pasar a llamar esto StoreLocatorPickupTransformer y dentro que hayan las stores y los droppoints
                this.droppoints = PhysicalStoreModelsTransformer.droppointsFromApi(apiDroppointLists);

                return this.droppoints;
            })
        );
    }

    public getDeliveryPoints(requestConfiguration: DroppointListsRequestConfiguration): Observable<PickupPointInfo[]> {
        return this.store.select(getStoreAndLanguage).pipe(
            first(),
            switchMap((storeAndLanguage) => {
                this.requestParameters = [
                    { key: 'languageId', value: storeAndLanguage.languageId },
                    { key: 'latitude', value: requestConfiguration.latitude },
                    { key: 'longitude', value: requestConfiguration.longitude },
                    { key: 'countryCode', value: storeAndLanguage.countryCode },
                    { key: 'reqSOD', value: 'true' }, // Para devoluciones. Poner en otro sitio se se utiliza en más.
                ];
                return this.apiDroppointListsService.getDeliveryPoints(this.requestParameters);
            }),
            map((apiDroppointLists: ApiDeliveryPointList): PickupPointInfo[] => {
                // Transforma los datos recibidos desde la API
                // TODO ECOMDUTI-20990 Hay que pasar a llamar esto StoreLocatorPickupTransformer y dentro que hayan las stores y los droppoints
                this.deliveryPoints = PhysicalStoreModelsTransformer.deliveryPointsFromApi(apiDroppointLists);
                return this.deliveryPoints;
            })
        );
    }
}
